import React from 'react';
import { Navigate } from 'react-router-dom';

const AdminProtectedRoute = ({ children }) => {
  const adminLoggedIn = sessionStorage.getItem('adminLoggedIn');
  const adminData = sessionStorage.getItem('adminData');
  
  // Check if logged in
  if (adminLoggedIn !== 'true' || !adminData) {
    return <Navigate to="/admin/login" replace />;
  }
  
  // Check 24-hour timeout
  try {
    const data = JSON.parse(adminData);
    const loginTime = new Date(data.loginTime);
    const now = new Date();
    const hoursSinceLogin = (now - loginTime) / (1000 * 60 * 60);
    
    // If more than 24 hours, logout
    if (hoursSinceLogin > 24) {
      sessionStorage.removeItem('adminLoggedIn');
      sessionStorage.removeItem('adminData');
      return <Navigate to="/admin/login" replace />;
    }
  } catch (error) {
    // If any error in parsing, logout
    sessionStorage.removeItem('adminLoggedIn');
    sessionStorage.removeItem('adminData');
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
};

export default AdminProtectedRoute;